'use strict';

export default {

    toggleClass(el, className) {
        if (el.classList) {
            el.classList.toggle(className);
        } else {
            var classes = el.className.split(' ');
            var existingIndex = classes.indexOf(className);

            if (existingIndex >= 0) {
                classes.splice(existingIndex, 1);
            } else {
                classes.push(className);
            }
            el.className = classes.join(' ');
        }
    },

    removeClass(el, className) {
        if (el.classList) {
            el.classList.remove(className);
        } else {
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    },

    addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += ' ' + className;
        }
    },

    hasClass(el, className) {
        var truthy = false;
        if (el.classList) {
            truthy = el.classList.contains(className);
        } else {
            truthy = new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        }
        return truthy;
    },

    setInnerHtml(html) {
        return {__html: html};
    },

    findChild(parent, className) {
        var child = null;
        for (var i = 0; i < parent.childNodes.length; i++) {
            if (parent.childNodes[i].className === className) {
                child = parent.childNodes[i];
                break;
            }
        }
        return child;
    },

    getWindowDimensions() {
        var w = window;
        var d = document;
        var e = d.documentElement;
        var g = d.getElementsByTagName('body')[0];
        var x = w.innerWidth || e.clientWidth || g.clientWidth;
        var y = w.innerHeight || e.clientHeight || g.clientHeight;
        return {'x': x, 'y': y};
    },

    setAttributes(el, attrs) {
        for (let key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }
};



// WEBPACK FOOTER //
// ./static/app/utils/dom.js